import { render, staticRenderFns } from "./SvgInformation.vue?vue&type=template&id=4c98563e&"
import script from "./SvgInformation.vue?vue&type=script&lang=js&"
export * from "./SvgInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports